<template src="./html/FilterBar.html"></template>

<script>
	import Ladda from 'ladda'
	import swal from 'sweetalert2'

	export default {
		props: ['user', 'isAuth', 'providers', 'customers', 'customer', 'selectedTo'],
		data () {
			return {
				projects: null,
				users: null,
				filter: {
					allowDate: false,
					date: null,
					text: null,
					providers: this.providers,
					customers: this.customers,
					customer_id: null,
				}
			}
		},
		watch: {
			'filter.allowDate'() {
				this.initDate()
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				if(this.customer) {
					this.filter.customer_id = this.customer.id
				}
			},
			reload() {
				this.$emit('reload')
			},
			collapse() {
				$(this.$refs.filter).collapse("toggle")
			},
			keyUpdoFilter(event) {
				if(this.filter.text) {
					if(event.code == 13) {
						this.doFilter()
					} else {
						if(event.code != 32) {
							this.doFilter()
						}
					}
				} else {
					this.doFilter()
				}
			},
			doFilter() {
				if(this.filter.text) {
					this.filter.text = this.filter.text.trimStart()
				}
				if(!this.filter.allowDate) {
					this.filter.date = null
				}
				this.$events.fire('filterSet', this.filter)
			},
			clearData() {
				this.filter.text = null
				this.filter.allowDate = false
				this.filter.data = null
			},
			reset() {
				this.clearData()
				this.$events.fire('filterReset', this.filter)
			},
			initDate() {
				var that = this
				var year = moment().format('YY')
				var month = moment().format('MM')
				var startDate = moment([year, month - 1])
				var endDate = moment()
				$('.daterange').daterangepicker({
					"startDate": startDate.format('DD/MM/YY'),
					"endDate": endDate.format('DD/MM/YY'),
					"locale": {
						"format": "DD/MM/YY",
						"separator": " - ",
						"applyLabel": "Aceptar",
						"cancelLabel": "Cancelar",
						"fromLabel": "From",
						"toLabel": "To",
						"customRangeLabel": "Custom",
						"daysOfWeek": [
							"Do",
							"Lu",
							"Ma",
							"Mi",
							"Ju",
							"Vi",
							"Sa",
						],
						"monthNames": [
							"Enero",
							"Febrero",
							"Marzo",
							"Abril",
							"Mayo",
							"Junio",
							"Julio",
							"Agosto",
							"Septiembre",
							"Octubre",
							"Noviembre",
							"Diciembre",
						],
						"firstDay": 1
					}
				}).on('hide.daterangepicker', function(e, picker) {
					that.filter.date = moment(picker.startDate).format('DD/MM/YY') + ' - ' +moment(picker.endDate).format('DD/MM/YY')
				})
				this.filter.date = startDate.format('DD/MM/YY') + ' - ' + endDate.format('DD/MM/YY')
			},
			invoicesOrders() {
				if(this.selectedTo.length > 0) {
					var data = {
						customer_id: this.customer.id,
						orders_ids: this.selectedTo,
						tax_id: this.$platform.setting.tax_id,
						currency_id: this.$platform.setting.currency_id,
					}
					var that = this
					swal.queue([{
						title: that.$t("messages.attention"),
						text: "Se creará una factura con los productos de los pedidos seleccionados",
						type: "warning",
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						preConfirm: function () {
							return new Promise(function (resolve) {
								that.$http.post('admin/management/invoices/orders', data)
								.then(response => {
									that.reload()
									swal(response.body.title, response.body.text, response.body.type);
								}).catch(function(response) {
									console.log(response)
								})
							})
						}
					}]).catch(swal.noop)
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/orders/views/FilterBar.vue